export default __webpack_public_path__ + "static/undraw_Relaxing_at_home_re_mror-baa3daef76e999b610fc8a7871a78217.svg";